/** Bundled HED schema configuration. */

export const localSchemaList = new Map([
  ['HED8.0.0', require('../../data/HED8.0.0.xml')],
  ['HED8.1.0', require('../../data/HED8.1.0.xml')],
  ['HED8.2.0', require('../../data/HED8.2.0.xml')],
  ['HED8.3.0', require('../../data/HED8.3.0.xml')],
  ['HED_score_1.0.0', require('../../data/HED_score_1.0.0.xml')],
  ['HED_score_1.1.0', require('../../data/HED_score_1.1.0.xml')],
  ['HED_testlib_1.0.2', require('../../data/HED_testlib_1.0.2.xml')],
  ['HED_testlib_2.0.0', require('../../data/HED_testlib_2.0.0.xml')],
])
